/* eslint-disable indent */
/* eslint-disable react/forbid-prop-types */
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { RadioInput, TextareaInput } from 'components/FormControl';
import { ADJUSTMENT_STATUSES } from 'constant';
import { formatDatetime } from 'utils/func';

function AdjustmentComment({ onSubmit, handleSubmit, control, errors, data, status, disabled }) {
  const { t } = useTranslation();

  const formatCreatedBy = (value) => (
    <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
      {`${value.createdBy?.fullname} - ${value.createdBy?.email}`}
    </span>
  );

  const formatCreatedAt = (value) => {
    const datetime = formatDatetime(value.createdAt, 'DD/MM/YYYY HH:mm:ss');
    return <small className="text-color-secondary">{datetime}</small>;
  };

  const formatComment = (value) => (
    <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
      {value.comment}
    </span>
  );

  const formatReply = (value) => (
    <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
      {value.reply}
    </span>
  );

  const formatEditable = (value) => (
    <span style={{ whiteSpace: 'pre-wrap' }} className="text-color-secondary">
      {value.editable ? t('formLayout.yes') : t('formLayout.no')}
    </span>
  );

  return (
    <div className="detail-info-council">
      <h4 className="mb-0">{t('projectAdjustment.requestUpdate.history')}</h4>

      <div className="ml-4 mt-2">
        {data?.length > 0 ? (
          <DataTable
            value={data}
            className="p-datatable-gridlines header-table"
            scrollable
            showGridlines
            emptyMessage={t('projectAdjustment.viewHistory.empty')}
            // isLoading={isLoading}
          >
            <Column
              header={t('proposal.history.no')}
              body={(rowData, { rowIndex }) => rowIndex + 1}
              style={{ width: '50px', textAlign: 'center' }}
            />
            <Column
              field="createdBy.fullname"
              header={t('projectAdjustment.viewHistory.createdBy')}
              style={{ minWidth: '10rem', textAlign: 'left' }}
              body={formatCreatedBy}
            />
            <Column
              field="comment"
              header={t('projectAdjustment.viewHistory.comment')}
              style={{ minWidth: '16rem', textAlign: 'left' }}
              body={formatComment}
            />
            <Column
              field="reply"
              header={t('projectAdjustment.viewHistory.reply')}
              style={{ minWidth: '16rem', textAlign: 'left' }}
              body={formatReply}
            />
            <Column
              field="createdAt"
              header={t('projectAdjustment.viewHistory.createdAt')}
              body={formatCreatedAt}
              style={{ minWidth: '5rem', maxWidth: '8rem', textAlign: 'left' }}
            />
            <Column
              field="editable"
              header={t('projectAdjustment.viewHistory.editable')}
              body={formatEditable}
              style={{ minWidth: '5rem', maxWidth: '8rem', textAlign: 'left' }}
            />
          </DataTable>
        ) : (
          <span className="text-color-secondary">
            {t('projectAdjustment.viewHistory.noCommentFromSpecialist')}
          </span>
        )}
        {data?.every((item) => item.isReplied) && status === ADJUSTMENT_STATUSES.SUBMITTED && (
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={`p-fluid ${data?.length > 0 ? 'mt-4' : 'mt-2'}`}
          >
            <div className="mb-2">
              <TextareaInput
                name="comment"
                control={control}
                errors={errors}
                row={6}
                label={t('projectAdjustment.requestUpdate.commentFromSpecialist')}
              />
            </div>

            <label htmlFor="isOpened" className="col-12 font-semibold pb-0">
              {t('projectAdjustment.requestUpdate.isEditable')}
            </label>
            <div className="col-12">
              <RadioInput
                name="editable"
                control={control}
                errors={errors}
                options={[
                  { value: true, name: t('formLayout.yes') },
                  { value: false, name: t('formLayout.no') },
                ]}
                inputField="value"
                defaultValue={false}
              />
            </div>

            <div className="flex justify-content-end gap-2">
              <Button
                label={t('submitDocument.comment')}
                className="w-7rem"
                severity="info"
                type="submit"
                disabled={disabled}
              />
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

AdjustmentComment.propTypes = {
  onSubmit: PropTypes.func,
  handleSubmit: PropTypes.func,
  control: PropTypes.object,
  errors: PropTypes.object,
  data: PropTypes.arrayOf(PropTypes.object),
  status: PropTypes.string,
  disabled: PropTypes.bool,
};

AdjustmentComment.defaultProps = {
  onSubmit: () => {},
  handleSubmit: () => {},
  control: {},
  errors: {},
  data: [],
  status: '',
  disabled: false,
};

export default React.memo(AdjustmentComment);
